import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment } from '@environment';
import { Post } from '@usheru-hff/shared/domain';
import { UsheruApi } from '@usheru-hff/shared/data-access-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocialService {
  constructor(
    private http: HttpClient,
    private usheruApi: UsheruApi,
    @Inject(ENVIRONMENT) private env: Environment
  ) {}
  // documentation:
  getSocialFeed(): Observable<Post[]> {
    if (this.isLocalEnv && this.placeholderData?.socialFeed) {
      const placeholder = typeof this.placeholderData.socialFeed === 'boolean' ? '1' : this.placeholderData.socialFeed;
      console.warn('Using placeholder data for socialFeed');
      return this.http.get<Post[]>(
        `https://cdnstatic.usheru.com/assets/placeholder-data/socialFeed-${placeholder}.json`
      );
    }

    return this.http.get<Post[]>(`${this.env.api.url}/socialFeed`, {
      headers: this.usheruApi.getStandardHeader()
    });
  }

  get isLocalEnv() {
    return this.env.mode == 'develop' || this.env.mode == 'demo';
  }

  get placeholderData() {
    return this.env?.placeholderData;
  }
}
